module.exports = __webpack_public_path__ + "img/banner2_13.7a993a94.jpg";